
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-drive-motorcycle-tours",
      function () {
        return require("private-next-pages/self-drive-motorcycle-tours.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/self-drive-motorcycle-tours"])
      });
    }
  